import { graphql } from "@opensea/graphql"
import { currencyIdentifierFragment } from "../utils"
import { useDefaultSwapCounterpartCurrencyFragment } from "./use-default-swap-counterpart-currency.fragment"

export const MobileCurrencyItemsActionBarFragment = graphql(
  `
    fragment MobileCurrencyItemsActionBar on Currency {
      symbol
      ...currencyIdentifier
      ...useDefaultSwapCounterpartCurrency
    }
  `,
  [currencyIdentifierFragment, useDefaultSwapCounterpartCurrencyFragment],
)
